import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=5e06b7ad&scoped=true"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=5e06b7ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06b7ad",
  null
  
)

export default component.exports